import { useMemo, useState } from "react";

export function useSortable(rows, initial = { key: null, dir: 1 }) {
  const [sort, setSort] = useState(initial);
  const sorted = useMemo(() => {
    const arr = Array.isArray(rows) ? rows : [];
    if (!sort.key) return arr;
    return [...arr].sort((a, b) => {
      const av = a?.[sort.key], bv = b?.[sort.key];
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      if (typeof av === "number" && typeof bv === "number") return sort.dir * (av - bv);
      if (typeof av === "boolean" || typeof bv === "boolean") return sort.dir * ((av === bv) ? 0 : av ? -1 : 1);
      return sort.dir * String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: "base" });
    });
  }, [rows, sort]);
  return { sorted, sort, setSort };
}

export const SortableTh = ({ label, k, sort, setSort, className = "text-left px-3 py-2 font-medium" }) => (
  <th
    className={`${className} cursor-pointer select-none hover:text-slate-900 whitespace-nowrap`}
    data-testid={`sort-th-${k}`}
    onClick={() => setSort((s) => ({ key: k, dir: s.key === k ? -s.dir : 1 }))}
    title="Click to sort"
  >
    {label}{sort.key === k ? (sort.dir === 1 ? " ▲" : " ▼") : ""}
  </th>
);
